export const NOTIFICATIONS_LIST_VIEW = "/notifications"
export const NOTIFICATION_VIEW = `${NOTIFICATIONS_LIST_VIEW}/:notificationId`
